/**
 * The text to show for a failed API call. The API still returns its English
 * `error` string (for other callers and logs) and now also a stable `code`; the
 * UI looks the code up under pageContent.apiErrors so the visitor reads it in
 * their language, falling back to the server's English text for a code that has
 * no translation yet, and to `fallback` when the response carries neither.
 */
export function apiErrorMessage(
  t: (key: string, options: Record<string, unknown>) => string,
  data: unknown,
  fallback: string,
  params: Record<string, unknown> = {},
): string {
  const body = data as { error?: unknown; code?: unknown } | null | undefined;
  const server = typeof body?.error === 'string' ? body.error : fallback;
  if (typeof body?.code !== 'string') return server;
  return t(`pageContent.apiErrors.${body.code}`, { defaultValue: server, ...params });
}
